import { type RouteRecordRaw } from 'vue-router';

export default {
  path: '/auth',
  name: 'auth',
  meta: {
    guest: true,
    layout: 'blank',
  },
  component: () => import('@/views/Auth/AuthView.vue'),
  redirect: { name: 'auth-login' },
  children: [
    {
      path: 'login',
      name: 'auth-login',
      component: () => import('@/components/Auth/Login/AuthLogin.vue'),
    },
    {
      path: 'forget-password',
      name: 'auth-forget-password',
      component: () => import('@/components/Auth/Login/LoginForgetPassword.vue'),
    },
    {
      path: 'reset-password',
      name: 'auth-reset-password',
      component: () => import('@/components/Auth/Login/LoginResetPassword.vue'),
    },
    {
      path: 'otp',
      children: [
        {
          path: 'verify',
          name: 'auth-otp-verify',
          component: () => import('@/components/Auth/Login/LoginOtpCode.vue'),
        },
        {
          path: 'reset',
          name: 'auth-otp-reset',
          component: () => import('@/components/Auth/Login/ResetPassOtp.vue'),
        },
      ],
    },
    {
      path: 'invitation',
      name: 'auth-invitation',
      component: () => import('@/components/Auth/Login/LoginViaInvitation.vue'),
    },
  ],
} as RouteRecordRaw;
